import Vue from "vue";
import Component from "vue-class-component";
import ABaseComponent from 'Components/Base/ABaseComponent';
import { IPorter, PorterKey, UpdatePorterCommandArguments, GenericFieldDescription } from "Api/CoreApi";
import { Prop, Watch } from "vue-property-decorator";
import ApiProvider from "Api/ApiProvider";
import axios, { AxiosInstance } from 'axios';
//import UserInformationComponent from "Components/Base/UserInformationComponent";
import PorterBudgetStore from "Store/porterBudget/porterBudget";
@Component({
    template: "#porter-information-component-template"
})
export default class PorterInformationComponent extends ABaseComponent {
    get porter() {
        return PorterBudgetStore.state.porter;
    }

    @Prop()
    public phone:string;

    @Prop()
    public email: string;

    async mounted() {
        //this.setDefaultSettings();
    }

    async created() {
        await PorterBudgetStore.dispatchFetchPorterBudget();
        //this.porter = await UserInformationComponent.getPorter();
    }
}

Vue.component('porter-information', PorterInformationComponent);